import { render, staticRenderFns } from "./CustomSettingsModal.vue?vue&type=template&id=746e87da"
import script from "./CustomSettingsModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomSettingsModal.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('746e87da')) {
      api.createRecord('746e87da', component.options)
    } else {
      api.reload('746e87da', component.options)
    }
    module.hot.accept("./CustomSettingsModal.vue?vue&type=template&id=746e87da", function () {
      api.rerender('746e87da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/cookies/CustomSettingsModal.vue"
export default component.exports